import { useAppConfig } from './useAppConfig';
import { useAuthSession } from './useAuthSession';
import { graphqlFetcher } from '../services/graphqlFetcher';

/**
 * GraphQL Fetcher hooks that's injected into all the graphql Generated Request hooks
 * via `src/graphql/codegen.yml` upon `yarn generate`
 */
export function useGraphqlFetcher<TData, TVariables>(query: string) {
  const { authToken, legacyToken } = useAuthSession();
  const {
    api: { graphql, useDirectHost },
    auth: { targetBg },
  } = useAppConfig();

  const accessToken = useDirectHost ? (legacyToken ?? '') : (authToken ?? '');

  return async (variables?: TVariables): Promise<TData> =>
    graphqlFetcher({
      endpoint: graphql,
      accessToken,
      targetBg,
      query,
      variables,
    });
}
